import { useEffect, useState } from 'react';


import request from '../helpers/requests';
import { getData, saveData, saveImage, getImage } from '../helpers/indexedDbHelper';

export const useRefresh = () => {

  const [change, setChange] = useState(0);
  const downloadImage = async (url, id, changeimage) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      await saveImage(id, {blob, changeimage});
    } catch (error) {
      console.error(`Error al descargar la imagen ${id}:`, error);
    }
  };

  const getInitData = async () => {

    console.log('veryfing');

      const validImages = async (id) => {
      const data = await getImage(id);
      return data;
    };



    const dataDb = await getData('menu');

    const hash = '7122121124d0santosaruba42390b0a72ac210dad121';
    const { data } = await request.get(`/all/menu/web/${hash}`);


    console.log(data.refresh_app, dataDb.value.refresh_app, 'dataDb.value.refresh_app')
    if (data.refresh_app != dataDb.value.refresh_app) {
      console.log("refresh")
      window.location.reload();
    }

    if (data.change_menu != dataDb.value.change_menu) {
      console.log('updateing menu');
      await saveData('menu', data);

      // Crear una lista de promesas para todas las imágenes
        const downloadPromises = [];

        data.data.forEach((item) => {
          const images = [
            ...item.menus.map((menu) => ({
              url: menu.image,
              changeimage: menu.changeimage,
              id: `menu-image-${menu.id}`,
            })),
            ...item.menus.map((menu) => ({
              url: menu.imagehorizontal,
              changeimage: menu.changeimagehorizontal,
              id: `menu-image-h-${menu.id}`,
            })),
          ];

          images.forEach(({ url, id, changeimage }) => {
            if (url) {
              const fullUrl = `https://admin.boostmymenu.com/images/menus/${url}`;
              downloadPromises.push(
                (async () => {
                  const validImage = await validImages(id);
                  if (validImage.data.changeimage != changeimage) {
                    console.log('Downloading image', fullUrl, id);
                    await downloadImage(fullUrl, id, changeimage);
                  }
                })()
              );
            }
          });
        });
      // Esperar a que todas las imágenes se descarguen
      await Promise.all(downloadPromises);
      setChange(Math.random(1,9999));
    }
  };

  useEffect(() => {
    setInterval(() => {
      getInitData();
    }, 300000);
  }, []);


  return { change, getInitData };


};
